import React from 'react';

import { tracker, Target } from 'services/tracking-manager';
import Icon from '../Icon';
import SmartLink from '../SmartLink/SmartLink';
import backIcon from 'assets/svg/arrow-left.svg';
import plusCircle from 'assets/svg/plus-circle.svg';
import './marketsCount.scss';

interface Props {
    marketsCount: number | undefined;
    topMarketsCount?: number;
    linkToMatch: string | null;
    isHiddenCount?: boolean;
    isPlusInCircle?: boolean;
}

const MarketsCount: React.FC<Props> = ({
    marketsCount = 0,
    isHiddenCount,
    linkToMatch,
    isPlusInCircle,
    topMarketsCount = 1,
}) => {
    const diff = marketsCount - topMarketsCount;

    return (
        <SmartLink
            styleName="markets-count"
            className="__app-markets-count"
            to={linkToMatch}
        >
            {diff >= 1 && !isHiddenCount ? (
                <span
                    styleName="value"
                    className="__app-MarketsCount-value"
                    {...tracker().markTarget(Target.GamesContainerMarket)}
                >
                    {isPlusInCircle ? (
                        <Icon
                            className="__app-MarketsCount-plus-circle"
                            styleName="plus-circle"
                            glyph={plusCircle}
                        />
                    ) : (
                        '+'
                    )}
                    {diff}
                </span>
            ) : (
                <div
                    styleName="rotate"
                    {...tracker().markTarget(Target.GamesContainerMarket)}
                >
                    <Icon glyph={backIcon} styleName="icon" />
                </div>
            )}
        </SmartLink>
    );
};

export default React.memo(MarketsCount);
